import React from 'react';

import { IpcInstance } from '../bootstrap';
import { CheckoutIpc, MessagePayload } from '../bootstrap/types';

const dummyIpc: IpcInstance<MessagePayload> = {
  send: () => undefined,
  listen: () => () => undefined,
  detach: () => undefined,
};

export const IpcContext = React.createContext<CheckoutIpc>(dummyIpc as CheckoutIpc);

export function useIpc() {
  return React.useContext(IpcContext);
}
